module.exports = "<img src=\"{{user.avatar}}\" alt=\"avatar\" title=\"avatar\" *ngIf=\"user.avatar\" [routerLink]=\"['/user', user.id]\">\n<img src=\"" + require("../../../assets/images/avatar_woman.png") + "\" alt=\"avatar\" title=\"avatar\" [routerLink]=\"['/user', user.id]\" *ngIf=\"!user.avatar && (user.sex === Sex.F || user.sex === Sex[Sex.F])\">\n<img src=\"" + require("../../../assets/images/avatar_man.png") + "\" alt=\"avatar\" title=\"avatar\" [routerLink]=\"['/user', user.id]\" *ngIf=\"!user.avatar && user.sex !== Sex.F && user.sex !== Sex[Sex.F]\">";


//////////////////
// WEBPACK FOOTER
// ./app/components/user-avatar/user-avatar.component.html
// module id = 1027
// module chunks = 0